import React, { FunctionComponent } from 'react';
import BoxedContent from 'ui/molecules/boxed-content';
import StatusTag from 'ui/atoms/status-tag';
import Translate from 'ui/atoms/translate';
import * as Styled from './styled';
import CopyButton from 'ui/molecules/copy-button';
import CardItem from 'src/ui/atoms/card-item';

export interface FriendReferralDetailsGeneralInfoProps {
  owningInvestorName: string;
  voucherCode: string;
  useTimes: number;
  active: boolean;
}

const FriendReferralDetailsGeneralInfo: FunctionComponent<FriendReferralDetailsGeneralInfoProps> = ({
  owningInvestorName,
  voucherCode,
  useTimes,
  active,
}) => {
  return (
    <BoxedContent releaseSpaceWhenTitleIsEmpty={true} title={<Translate name="common.generalInformation" />}>
      <CardItem title={<Translate name="issuerFriendReferrals.table.referrer" />} content={owningInvestorName} />
      <CardItem
        title={<Translate name="issuerFriendReferrals.table.voucherCode" />}
        content={
          <Styled.VoucherCodeContainer>
            <Styled.VoucherCode>{voucherCode}</Styled.VoucherCode>
            <CopyButton valueToCopy={voucherCode} />
          </Styled.VoucherCodeContainer>
        }
      />
      <CardItem title={<Translate name="issuerFriendReferrals.table.useNumber" />} content={useTimes} />
      <CardItem
        title={<Translate name="issuerFriendReferrals.table.status" />}
        content={
          <StatusTag variant={active ? 'success' : 'danger'} truncate={true}>
            <Translate name={`issuerProductDetails.campaigns.status.${active ? 'active' : 'deactivated'}`} />
          </StatusTag>
        }
      />
    </BoxedContent>
  );
};

export default FriendReferralDetailsGeneralInfo;
